import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useSession } from '@/lib/session';

export function DashboardPage() {
  const { t } = useTranslation();
  const { user, activeMembership } = useSession();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">{t('dashboard.title')}</h1>
        <p className="text-muted-foreground">
          {t('dashboard.welcome', { name: user?.name ?? '' })}
        </p>
      </div>

      {activeMembership ? (
        <Card>
          <CardHeader>
            <CardTitle>{activeMembership.tenant_name}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-1 text-sm">
            <p>
              <span className="text-muted-foreground">{t('tenant.role')}: </span>
              {t(`tenant.role_${activeMembership.role}`)}
            </p>
            <p className="text-muted-foreground">
              {activeMembership.scoped ? t('tenant.scoped') : t('tenant.unscoped')}
            </p>
          </CardContent>
        </Card>
      ) : (
        <Alert>
          {/* „Wende dich an den Betreiber" waere ausgerechnet fuer den
              Betreiber falsch — er landet hier, solange es keinen Mandanten
              gibt, und braucht den Weg zur Anlage statt einer Sackgasse. */}
          <AlertDescription>
            {t(user?.is_platform_admin ? 'tenant.empty_platform_admin' : 'tenant.empty')}
          </AlertDescription>
        </Alert>
      )}

      <Alert>
        <AlertDescription>{t('dashboard.phase_hint')}</AlertDescription>
      </Alert>
    </div>
  );
}
